import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PricingDomainModule } from '@nbg-digital/pricing/domain';

@NgModule({
  imports: [CommonModule, PricingDomainModule],
})
export class PricingApiModule {}
